import * as React from 'react'
import { memo } from 'react'
const SvgTrain = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 13.176 16"
  >
    <path d="M0 11.4V2.821A2.07 2.07 0 0 1 .529 1.34 3.4 3.4 0 0 1 1.963.482a9 9 0 0 1 2.1-.391q1.2-.093 2.52-.093 1.372 0 2.568.093a9 9 0 0 1 2.092.388 3.24 3.24 0 0 1 1.413.858 2.1 2.1 0 0 1 .516 1.484V11.4a2.62 2.62 0 0 1-.79 1.925 2.62 2.62 0 0 1-1.925.79l1.412 1.412V16h-.8l-1.882-1.882H3.974L2.1 16h-.8v-.471l1.412-1.412a2.62 2.62 0 0 1-1.925-.79A2.62 2.62 0 0 1 0 11.4m.941-3.873h5.176v-4.2H.941Zm6.118 0h5.176v-4.2H7.059ZM3.29 11.871a1.03 1.03 0 0 0 .754-.3 1 1 0 0 0 .3-.749 1.03 1.03 0 0 0-.3-.754 1 1 0 0 0-.749-.3 1.03 1.03 0 0 0-.754.3 1 1 0 0 0-.3.749 1.03 1.03 0 0 0 .3.754 1 1 0 0 0 .749.302Zm6.588 0a1.03 1.03 0 0 0 .754-.3 1 1 0 0 0 .3-.749 1.03 1.03 0 0 0-.3-.754 1 1 0 0 0-.749-.3 1.03 1.03 0 0 0-.754.3 1 1 0 0 0-.3.749 1.03 1.03 0 0 0 .3.754 1 1 0 0 0 .749.302Z" />
  </svg>
)
const Memo = memo(SvgTrain)
export default Memo
